import { API_CALL } from 'actions/actionConstants'
import { FETCH_LOYALTY_CLAIM_CAMPAIGNS } from 'actions/apiActionConstants'
import type { AppAction } from 'actions/types/ActionTypes'
import requestLoyaltyActiveClaimCampaigns from 'api/loyalty/requestLoyaltyActiveClaimCampaigns'

function fetchLoyaltyClaimCampaigns(): AppAction {
  return (dispatch, getState) => {
    const state = getState()

    if (
      state.loyalty.claimCampaigns.fetching ||
      state.loyalty.claimCampaigns.data
    ) {
      return
    }

    dispatch({
      type: API_CALL,
      api: FETCH_LOYALTY_CLAIM_CAMPAIGNS,
      request: requestLoyaltyActiveClaimCampaigns,
    })
  }
}

export default fetchLoyaltyClaimCampaigns
